import { render, staticRenderFns } from "./SplitListFunc.vue?vue&type=template&id=20d0c853&scoped=true"
import script from "./SplitListFunc.vue?vue&type=script&lang=js"
export * from "./SplitListFunc.vue?vue&type=script&lang=js"
import style0 from "./SplitListFunc.vue?vue&type=style&index=0&id=20d0c853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0c853",
  null
  
)

export default component.exports